import { createComponent } from '@carvana/merch-components';

export const TagWrapper = createComponent('div', {
  className:
    'flex font-bold h-20 items-center leading-5 px-8 rounded-full text-xs w-fit'
});

export const StatusTagWrapper = createComponent('div', {
  className:
    'border border-grey-2 border-l-0 border-t-0 font-bold px-8 py-4 rounded-br-md text-white text-xs'
});
